import React from "react";
import './AddButton.css';
import './add_button2.css';
import { useTranslation } from "react-i18next";

const AddButton = ({
    text = 'Add',
    onClick,
    color,
    border,
    backgroundColor,
    variant = 'default',
    isSubmitting = false,
    disabled = false,
    className = "",
    style,
    ...props
}) => {

    const { t } = useTranslation();

    const buttonStyle = { ...style };

    if (backgroundColor) {
        buttonStyle.backgroundColor = backgroundColor;
        buttonStyle.background = backgroundColor;
    }

    if (color) {
        buttonStyle.color = color;
    }

    if (border) {
        buttonStyle.border = border;
    }

    const isDisabled = isSubmitting || disabled;

    return (
        <div
            onClick={!isDisabled ? onClick : undefined}
            className={`add-button common-text ftw-4 ${
                variant === 'compact' ? 'compact' : ''
            } ${isDisabled ? 'disabled' : ''} ${className}`}
            style={buttonStyle}
            {...props}
        >
            {t(text)}
        </div>
    );
};

export default AddButton;